export default __webpack_public_path__ + "3b768081270ab5e6f91ee6c70fbf5766.png";